import React, { useState } from "react";
import * as Accordion from "@radix-ui/react-accordion";

const accordionRootClasses = `
w-[1228px] rounded-lg bg-brand-slate flex flex-col h-[full]
`;

const AccordionComponent = () => {
  const [isSMOpen, setIsSMOpen] = useState(false);
  const [isWPOpen, setIsWPOpen] = useState(false);

  return (
    <div className="flex flex-col w-full items-center justify-center mt-10">
      <Accordion.Root className={accordionRootClasses} type="multiple">
        <Accordion.Item
          value="item-1"
          className="overflow-hidden bg-brand-slate first:mt-0 first:rounded-lg last:rounded-lg cursor-pointer w-full hover:bg-brand-slate/40"
        >
          <Accordion.Trigger
            className="
                    group flex flex-1 h-[102px] items-center 
                    justify-between px-5 text-[15px]
                    w-full 
                    hover:bg-brand-slate/40"
            onClick={() => setIsSMOpen(!isSMOpen)}
          >
            <div className="flex flex-col w-[50px] items-start mr-2">
              {isSMOpen ? (
                <span
                  className="icon-[ic--baseline-minus]"
                  style={{ width: "2rem", height: "2rem" }}
                ></span>
              ) : (
                <span
                  className="icon-[ic--baseline-plus]"
                  style={{ width: "2rem", height: "2rem" }}
                ></span>
              )}
            </div>
            <div className="flex flex-col w-[550px]">
              <p className="font-bold text-start">Social Media</p>
              <p className="text-start -mt-3 text-slate-300 opacity-75">
                Mass delete your content from major social media platforms.
              </p>
            </div>
            <div className="flex flex-col w-[400px] items-center">
              <p className="text-start text-slate-300 opacity-75">Limited</p>
            </div>
            <div className="flex flex-col w-[400px] items-center">
              <span
                className="icon-[ic--sharp-check]"
                style={{ width: "2rem", height: "2rem", color: "#306AFF" }}
              ></span>
            </div>
            <div className="flex flex-col w-[400px] items-center">
              <span
                className="icon-[ic--sharp-check]"
                style={{ width: "2rem", height: "2rem", color: "#7551CB" }}
              ></span>
            </div>
          </Accordion.Trigger>

          <Accordion.Content
            className="
                    overflow-hidden bg-brand-slate text-[15px] text-white data-[state=closed]:animate-slideUp data-[state=open]:animate-slideDown"
          >
            <div className="flex flex-1">
              <div className="flex flex-col w-[50px] items-start"></div>
              <div className="flex flex-col items-start w-[550px] ml-7">
                <p className="text-start text-slate-300 opacity-75">Twitter</p>
              </div>
              <div className="flex flex-col w-[400px] items-center mr-1">
                <p className="text-start text-slate-300 opacity-75">Limited</p>
              </div>
              <div className="flex flex-col w-[400px] items-center justify-center">
                <span
                  className="icon-[ic--sharp-check]"
                  style={{ width: "2rem", height: "2rem", color: "#306AFF" }}
                ></span>
              </div>
              <div className="flex flex-col w-[400px] items-center justify-center mr-5">
                <span
                  className="icon-[ic--sharp-check]"
                  style={{ width: "2rem", height: "2rem", color: "#7551CB" }}
                ></span>
              </div>
            </div>

            <div className="ml-3 h-[1px] w-[1200px] bg-slate-500 opacity-15"></div>

            <div className="flex flex-1">
              <div className="flex flex-col w-[50px] items-start"></div>
              <div className="flex flex-col items-start w-[550px] ml-7">
                <p className="text-start text-slate-300 opacity-75">Reddit</p>
              </div>
              <div className="flex flex-col w-[400px] items-center mr-1">
                <p className="text-start text-slate-300 opacity-75">Limited</p>
              </div>
              <div className="flex flex-col w-[400px] items-center justify-center">
                <span
                  className="icon-[ic--sharp-check]"
                  style={{ width: "2rem", height: "2rem", color: "#306AFF" }}
                ></span>
              </div>
              <div className="flex flex-col w-[400px] items-center justify-center mr-5">
                <span
                  className="icon-[ic--sharp-check]"
                  style={{ width: "2rem", height: "2rem", color: "#7551CB" }}
                ></span>
              </div>
            </div>

            <div className="ml-3 h-[1px] w-[1200px] bg-slate-500 opacity-15"></div>

            <div className="flex flex-1">
              <div className="flex flex-col w-[50px] items-start"></div>
              <div className="flex flex-col items-start w-[550px] ml-8">
                <p className="text-start text-slate-300 opacity-75">Discord</p>
              </div>
              <div className="flex flex-col w-[400px] items-center ml-[6.8rem]">
                <p className="text-start text-slate-300 opacity-75">Up to past 30 days</p>
              </div>
              <div className="flex flex-col w-[400px] items-center justify-center mr-9">
                <span
                  className="icon-[ic--sharp-check]"
                  style={{ width: "2rem", height: "2rem", color: "#306AFF" }}
                ></span>
              </div>
              <div className="flex flex-col w-[400px] items-center justify-center mr-9">
                <span
                  className="icon-[ic--sharp-check]"
                  style={{ width: "2rem", height: "2rem", color: "#7551CB" }}
                ></span>
              </div>
            </div>

            <div className="ml-3 h-[1px] w-[1200px] bg-slate-500 opacity-15"></div>

            <div className="flex flex-1">
              <div className="flex flex-col w-[50px] items-start"></div>
              <div className="flex flex-col items-start w-[550px] ml-8">
                <p className="text-start text-slate-300 opacity-75">Facebook</p>
              </div>
              <div className="flex flex-col w-[400px] items-center ml-[6.8rem]">
                <p className="text-start text-slate-300 opacity-75">Up to past 30 days</p>
              </div>
              <div className="flex flex-col w-[400px] items-center justify-center mr-9">
                <span
                  className="icon-[ic--sharp-check]"
                  style={{ width: "2rem", height: "2rem", color: "#306AFF" }}
                ></span>
              </div>
              <div className="flex flex-col w-[400px] items-center justify-center mr-9">
                <span
                  className="icon-[ic--sharp-check]"
                  style={{ width: "2rem", height: "2rem", color: "#7551CB" }}
                ></span>
              </div>
            </div>

            <div className="ml-3 h-[1px] w-[1200px] bg-slate-500 opacity-15"></div>

            <div className="flex flex-1">
              <div className="flex flex-col w-[50px] items-start"></div>
              <div className="flex flex-col items-start w-[550px] ml-8">
                <p className="text-start text-slate-300 opacity-75">Steam</p>
              </div>
              <div className="flex flex-col w-[400px] items-center justify-center">
                <span
                  className="icon-[system-uicons--cross]"
                  style={{ width: "2rem", height: "2rem" }}
                ></span>
              </div>
              <div className="flex flex-col w-[400px] items-center justify-center">
                <span
                  className="icon-[ic--sharp-check]"
                  style={{ width: "2rem", height: "2rem", color: "#306AFF" }}
                ></span>
              </div>
              <div className="flex flex-col w-[400px] items-center justify-center mr-5">
                <span
                  className="icon-[ic--sharp-check]"
                  style={{ width: "2rem", height: "2rem", color: "#7551CB" }}
                ></span>
              </div>
            </div>

            <div className="ml-3 h-[1px] w-[1200px] bg-slate-500 opacity-15"></div>

            <div className="flex flex-1">
              <div className="flex flex-col w-[50px] items-start"></div>
              <div className="flex flex-col items-start w-[550px] ml-8">
                <p className="text-start text-slate-300 opacity-75">Imgur</p>
              </div>
              <div className="flex flex-col w-[400px] items-center justify-center">
                <span
                  className="icon-[system-uicons--cross]"
                  style={{ width: "2rem", height: "2rem" }}
                ></span>
              </div>
              <div className="flex flex-col w-[400px] items-center justify-center">
                <span
                  className="icon-[ic--sharp-check]"
                  style={{ width: "2rem", height: "2rem", color: "#306AFF" }}
                ></span>
              </div>
              <div className="flex flex-col w-[400px] items-center justify-center mr-5">
                <span
                  className="icon-[ic--sharp-check]"
                  style={{ width: "2rem", height: "2rem", color: "#7551CB" }}
                ></span>
              </div>
            </div>

            <div className="ml-3 h-[1px] w-[1200px] bg-slate-500 opacity-15"></div>

            <div className="flex flex-1">
              <div className="flex flex-col w-[50px] items-start"></div>
              <div className="flex flex-col items-start w-[550px] ml-8">
                <p className="text-start text-slate-300 opacity-75">Deviantart</p>
              </div>
              <div className="flex flex-col w-[400px] items-center justify-center">
                <span
                  className="icon-[system-uicons--cross]"
                  style={{ width: "2rem", height: "2rem" }}
                ></span>
              </div>
              <div className="flex flex-col w-[400px] items-center justify-center">
                <span
                  className="icon-[ic--sharp-check]"
                  style={{ width: "2rem", height: "2rem", color: "#306AFF" }}
                ></span>
              </div>
              <div className="flex flex-col w-[400px] items-center justify-center mr-5">
                <span
                  className="icon-[ic--sharp-check]"
                  style={{ width: "2rem", height: "2rem", color: "#7551CB" }}
                ></span>
              </div>
            </div>

            <div className="ml-3 h-[1px] w-[1200px] bg-slate-500 opacity-15"></div>

            <div className="flex flex-1">
              <div className="flex flex-col w-[50px] items-start"></div>
              <div className="flex flex-col items-start w-[550px] ml-8">
                <p className="text-start text-slate-300 opacity-75">Pinterest</p>
              </div>
              <div className="flex flex-col w-[400px] items-center justify-center">
                <span
                  className="icon-[system-uicons--cross]"
                  style={{ width: "2rem", height: "2rem" }}
                ></span>
              </div>
              <div className="flex flex-col w-[400px] items-center justify-center">
                <span
                  className="icon-[ic--sharp-check]"
                  style={{ width: "2rem", height: "2rem", color: "#306AFF" }}
                ></span>
              </div>
              <div className="flex flex-col w-[400px] items-center justify-center mr-5">
                <span
                  className="icon-[ic--sharp-check]"
                  style={{ width: "2rem", height: "2rem", color: "#7551CB" }}
                ></span>
              </div>
            </div>

            <div className="ml-3 h-[1px] w-[1200px] bg-slate-500 opacity-15"></div>

            <div className="flex flex-1">
              <div className="flex flex-col w-[50px] items-start"></div>
              <div className="flex flex-col items-start w-[550px] ml-8">
                <p className="text-start text-slate-300 opacity-75">Tumblr</p>
              </div>
              <div className="flex flex-col w-[400px] items-center justify-center">
                <span
                  className="icon-[system-uicons--cross]"
                  style={{ width: "2rem", height: "2rem" }}
                ></span>
              </div>
              <div className="flex flex-col w-[400px] items-center justify-center">
                <span
                  className="icon-[ic--sharp-check]"
                  style={{ width: "2rem", height: "2rem", color: "#306AFF" }}
                ></span>
              </div>
              <div className="flex flex-col w-[400px] items-center justify-center mr-5">
                <span
                  className="icon-[ic--sharp-check]"
                  style={{ width: "2rem", height: "2rem", color: "#7551CB" }}
                ></span>
              </div>
            </div>

            <div className="ml-3 h-[1px] w-[1200px] bg-slate-500 opacity-15"></div>

            <div className="flex flex-1">
              <div className="flex flex-col w-[50px] items-start"></div>
              <div className="flex flex-col items-start w-[550px] ml-8">
                <p className="text-start text-slate-300 opacity-75">Telegram</p>
              </div>
              <div className="flex flex-col w-[400px] items-center justify-center">
                <span
                  className="icon-[system-uicons--cross]"
                  style={{ width: "2rem", height: "2rem" }}
                ></span>
              </div>
              <div className="flex flex-col w-[400px] items-center justify-center">
                <span
                  className="icon-[ic--sharp-check]"
                  style={{ width: "2rem", height: "2rem", color: "#306AFF" }}
                ></span>
              </div>
              <div className="flex flex-col w-[400px] items-center justify-center mr-5">
                <span
                  className="icon-[ic--sharp-check]"
                  style={{ width: "2rem", height: "2rem", color: "#7551CB" }}
                ></span>
              </div>
            </div>

            <div className="ml-3 h-[1px] w-[1200px] bg-slate-500 opacity-15"></div>

            <div className="flex flex-1">
              <div className="flex flex-col w-[50px] items-start"></div>
              <div className="flex flex-col items-start w-[550px] ml-8">
                <p className="text-start text-slate-300 opacity-75">MyAnimeList</p>
              </div>
              <div className="flex flex-col w-[400px] items-center justify-center">
                <span
                  className="icon-[system-uicons--cross]"
                  style={{ width: "2rem", height: "2rem" }}
                ></span>
              </div>
              <div className="flex flex-col w-[400px] items-center justify-center">
                <span
                  className="icon-[ic--sharp-check]"
                  style={{ width: "2rem", height: "2rem", color: "#306AFF" }}
                ></span>
              </div>
              <div className="flex flex-col w-[400px] items-center justify-center mr-5">
                <span
                  className="icon-[ic--sharp-check]"
                  style={{ width: "2rem", height: "2rem", color: "#7551CB" }}
                ></span>
              </div>
            </div>

            <div className="ml-3 h-[1px] w-[1200px] bg-slate-500 opacity-15"></div>

            <div className="flex flex-1">
              <div className="flex flex-col w-[50px] items-start"></div>
              <div className="flex flex-col items-start w-[550px] ml-8">
                <p className="text-start text-slate-300 opacity-75">Disqus</p>
              </div>
              <div className="flex flex-col w-[400px] items-center justify-center">
                <span
                  className="icon-[system-uicons--cross]"
                  style={{ width: "2rem", height: "2rem" }}
                ></span>
              </div>
              <div className="flex flex-col w-[400px] items-center justify-center">
                <span
                  className="icon-[ic--sharp-check]"
                  style={{ width: "2rem", height: "2rem", color: "#306AFF" }}
                ></span>
              </div>
              <div className="flex flex-col w-[400px] items-center justify-center mr-5">
                <span
                  className="icon-[ic--sharp-check]"
                  style={{ width: "2rem", height: "2rem", color: "#7551CB" }}
                ></span>
              </div>
            </div>

            <div className="ml-3 h-[1px] w-[1200px] bg-slate-500 opacity-15"></div>

            <div className="flex flex-1">
              <div className="flex flex-col w-[50px] items-start"></div>
              <div className="flex flex-col items-start w-[550px] ml-8">
                <p className="text-start text-slate-300 opacity-75">Gyazo</p>
              </div>
              <div className="flex flex-col w-[400px] items-center justify-center">
                <span
                  className="icon-[system-uicons--cross]"
                  style={{ width: "2rem", height: "2rem" }}
                ></span>
              </div>
              <div className="flex flex-col w-[400px] items-center justify-center">
                <span
                  className="icon-[ic--sharp-check]"
                  style={{ width: "2rem", height: "2rem", color: "#306AFF" }}
                ></span>
              </div>
              <div className="flex flex-col w-[400px] items-center justify-center mr-5">
                <span
                  className="icon-[ic--sharp-check]"
                  style={{ width: "2rem", height: "2rem", color: "#7551CB" }}
                ></span>
              </div>
            </div>

            <div className="ml-3 h-[1px] w-[1200px] bg-slate-500 opacity-15"></div>

            <div className="flex flex-1">
              <div className="flex flex-col w-[50px] items-start"></div>
              <div className="flex flex-col items-start w-[550px] ml-8">
                <p className="text-start text-slate-300 opacity-75">Bumble</p>
              </div>
              <div className="flex flex-col w-[400px] items-center justify-center">
                <span
                  className="icon-[system-uicons--cross]"
                  style={{ width: "2rem", height: "2rem" }}
                ></span>
              </div>
              <div className="flex flex-col w-[400px] items-center justify-center">
                <span
                  className="icon-[ic--sharp-check]"
                  style={{ width: "2rem", height: "2rem", color: "#306AFF" }}
                ></span>
              </div>
              <div className="flex flex-col w-[400px] items-center justify-center mr-5">
                <span
                  className="icon-[ic--sharp-check]"
                  style={{ width: "2rem", height: "2rem", color: "#7551CB" }}
                ></span>
              </div>
            </div>

            <div className="ml-3 h-[1px] w-[1200px] bg-slate-500 opacity-15"></div>

            <div className="flex flex-1">
              <div className="flex flex-col w-[50px] items-start"></div>
              <div className="flex flex-col items-start w-[550px] ml-8">
                <p className="text-start text-slate-300 opacity-75">Bluesky</p>
              </div>
              <div className="flex flex-col w-[400px] items-center justify-center">
                <span
                  className="icon-[system-uicons--cross]"
                  style={{ width: "2rem", height: "2rem" }}
                ></span>
              </div>
              <div className="flex flex-col w-[400px] items-center justify-center">
                <span
                  className="icon-[ic--sharp-check]"
                  style={{ width: "2rem", height: "2rem", color: "#306AFF" }}
                ></span>
              </div>
              <div className="flex flex-col w-[400px] items-center justify-center mr-5">
                <span
                  className="icon-[ic--sharp-check]"
                  style={{ width: "2rem", height: "2rem", color: "#7551CB" }}
                ></span>
              </div>
            </div>

            <div className="ml-3 h-[1px] w-[1200px] bg-slate-500 opacity-15"></div>

            <div className="flex flex-1">
              <div className="flex flex-col w-[50px] items-start"></div>
              <div className="flex flex-col items-start w-[550px] ml-8">
                <p className="text-start text-slate-300 opacity-75">Mastodon</p>
              </div>
              <div className="flex flex-col w-[400px] items-center justify-center">
                <span
                  className="icon-[system-uicons--cross]"
                  style={{ width: "2rem", height: "2rem" }}
                ></span>
              </div>
              <div className="flex flex-col w-[400px] items-center justify-center">
                <span
                  className="icon-[ic--sharp-check]"
                  style={{ width: "2rem", height: "2rem", color: "#306AFF" }}
                ></span>
              </div>
              <div className="flex flex-col w-[400px] items-center justify-center mr-5">
                <span
                  className="icon-[ic--sharp-check]"
                  style={{ width: "2rem", height: "2rem", color: "#7551CB" }}
                ></span>
              </div>
            </div>
          </Accordion.Content>
        </Accordion.Item>
      </Accordion.Root>

      <Accordion.Root className={accordionRootClasses + "mt-5"} type="multiple">
        <Accordion.Item
          value="item-2"
          className="overflow-hidden bg-brand-slate first:mt-0 first:rounded-lg last:rounded-lg cursor-pointer w-full hover:bg-brand-slate/40"
        >
          <Accordion.Trigger
            className="
                    group flex flex-1 h-[102px] items-center 
                    justify-between px-5 text-[15px]
                    w-full 
                    hover:bg-brand-slate/40"
            onClick={() => setIsWPOpen(!isWPOpen)}
          >
            <div className="flex flex-col w-[50px] items-start mr-2">
              {isWPOpen ? (
                <span
                  className="icon-[ic--baseline-minus]"
                  style={{ width: "2rem", height: "2rem" }}
                ></span>
              ) : (
                <span
                  className="icon-[ic--baseline-plus]"
                  style={{ width: "2rem", height: "2rem" }}
                ></span>
              )}
            </div>
            <div className="flex flex-col w-[550px]">
              <p className="font-bold text-start">Work and productivity</p>
              <p className="text-start -mt-3 text-slate-300 opacity-75">
                Mass delete your content from major work and productivity platforms.
              </p>
            </div>
            <div className="flex flex-col w-[400px] items-center">
              <span
                className="icon-[system-uicons--cross]"
                style={{ width: "2rem", height: "2rem" }}
              ></span>
            </div>
            <div className="flex flex-col w-[400px] items-center">
              <span
                className="icon-[system-uicons--cross]"
                style={{ width: "2rem", height: "2rem" }}
              ></span>
            </div>
            <div className="flex flex-col w-[400px] items-center">
              <span
                className="icon-[ic--sharp-check]"
                style={{ width: "2rem", height: "2rem", color: "#7551CB" }}
              ></span>
            </div>
          </Accordion.Trigger>

          <Accordion.Content className="overflow-hidden bg-brand-slate text-[15px] text-white data-[state=closed]:animate-slideUp data-[state=open]:animate-slideDown">
            <div className="flex flex-1">
              <div className="flex flex-col w-[50px] items-start"></div>
              <div className="flex flex-col items-start w-[550px] ml-7">
                <p className="text-start text-slate-300 opacity-75">LinkedIn</p>
              </div>
              <div className="flex flex-col w-[400px] items-center">
                <span
                  className="icon-[system-uicons--cross]"
                  style={{ width: "2rem", height: "2rem" }}
                ></span>
              </div>
              <div className="flex flex-col w-[400px] items-center">
                <span
                  className="icon-[system-uicons--cross]"
                  style={{ width: "2rem", height: "2rem" }}
                ></span>
              </div>
              <div className="flex flex-col w-[400px] items-center mr-5">
                <span
                  className="icon-[ic--sharp-check]"
                  style={{ width: "2rem", height: "2rem", color: "#7551CB" }}
                ></span>
              </div>
            </div>

            <div className="ml-3 h-[1px] w-[1200px] bg-slate-500 opacity-15"></div>

            <div className="flex flex-1">
              <div className="flex flex-col w-[50px] items-start"></div>
              <div className="flex flex-col items-start w-[550px] ml-7">
                <p className="text-start text-slate-300 opacity-75">Slack</p>
              </div>
              <div className="flex flex-col w-[400px] items-center">
                <span
                  className="icon-[system-uicons--cross]"
                  style={{ width: "2rem", height: "2rem" }}
                ></span>
              </div>
              <div className="flex flex-col w-[400px] items-center">
                <span
                  className="icon-[system-uicons--cross]"
                  style={{ width: "2rem", height: "2rem" }}
                ></span>
              </div>
              <div className="flex flex-col w-[400px] items-center mr-5">
                <span
                  className="icon-[ic--sharp-check]"
                  style={{ width: "2rem", height: "2rem", color: "#7551CB" }}
                ></span>
              </div>
            </div>

            <div className="ml-3 h-[1px] w-[1200px] bg-slate-500 opacity-15"></div>

            <div className="flex flex-1">
              <div className="flex flex-col w-[50px] items-start"></div>
              <div className="flex flex-col items-start w-[550px] ml-7">
                <p className="text-start text-slate-300 opacity-75">Skype</p>
              </div>
              <div className="flex flex-col w-[400px] items-center">
                <span
                  className="icon-[system-uicons--cross]"
                  style={{ width: "2rem", height: "2rem" }}
                ></span>
              </div>
              <div className="flex flex-col w-[400px] items-center">
                <span
                  className="icon-[system-uicons--cross]"
                  style={{ width: "2rem", height: "2rem" }}
                ></span>
              </div>
              <div className="flex flex-col w-[400px] items-center mr-5">
                <span
                  className="icon-[ic--sharp-check]"
                  style={{ width: "2rem", height: "2rem", color: "#7551CB" }}
                ></span>
              </div>
            </div>

            <div className="ml-3 h-[1px] w-[1200px] bg-slate-500 opacity-15"></div>

            <div className="flex flex-1">
              <div className="flex flex-col w-[50px] items-start"></div>
              <div className="flex flex-col items-start w-[550px] ml-7">
                <p className="text-start text-slate-300 opacity-75">StackExchange</p>
              </div>
              <div className="flex flex-col w-[400px] items-center">
                <span
                  className="icon-[system-uicons--cross]"
                  style={{ width: "2rem", height: "2rem" }}
                ></span>
              </div>
              <div className="flex flex-col w-[400px] items-center">
                <span
                  className="icon-[system-uicons--cross]"
                  style={{ width: "2rem", height: "2rem" }}
                ></span>
              </div>
              <div className="flex flex-col w-[400px] items-center mr-5">
                <span
                  className="icon-[ic--sharp-check]"
                  style={{ width: "2rem", height: "2rem", color: "#7551CB" }}
                ></span>
              </div>
            </div>

            <div className="ml-3 h-[1px] w-[1200px] bg-slate-500 opacity-15"></div>

            <div className="flex flex-1">
              <div className="flex flex-col w-[50px] items-start"></div>
              <div className="flex flex-col items-start w-[550px] ml-7">
                <p className="text-start text-slate-300 opacity-75">Email</p>
              </div>
              <div className="flex flex-col w-[400px] items-center">
                <span
                  className="icon-[system-uicons--cross]"
                  style={{ width: "2rem", height: "2rem" }}
                ></span>
              </div>
              <div className="flex flex-col w-[400px] items-center">
                <span
                  className="icon-[system-uicons--cross]"
                  style={{ width: "2rem", height: "2rem" }}
                ></span>
              </div>
              <div className="flex flex-col w-[400px] items-center mr-5">
                <span
                  className="icon-[ic--sharp-check]"
                  style={{ width: "2rem", height: "2rem", color: "#7551CB" }}
                ></span>
              </div>
            </div>

            <div className="ml-3 h-[1px] w-[1200px] bg-slate-500 opacity-15"></div>

            <div className="flex flex-1">
              <div className="flex flex-col w-[50px] items-start"></div>
              <div className="flex flex-col items-start w-[550px] ml-7">
                <p className="text-start text-slate-300 opacity-75">Wordpress</p>
              </div>
              <div className="flex flex-col w-[400px] items-center">
                <span
                  className="icon-[system-uicons--cross]"
                  style={{ width: "2rem", height: "2rem" }}
                ></span>
              </div>
              <div className="flex flex-col w-[400px] items-center">
                <span
                  className="icon-[system-uicons--cross]"
                  style={{ width: "2rem", height: "2rem" }}
                ></span>
              </div>
              <div className="flex flex-col w-[400px] items-center mr-5">
                <span
                  className="icon-[ic--sharp-check]"
                  style={{ width: "2rem", height: "2rem", color: "#7551CB" }}
                ></span>
              </div>
            </div>

            <div className="ml-3 h-[1px] w-[1200px] bg-slate-500 opacity-15"></div>

            <div className="flex flex-1">
              <div className="flex flex-col w-[50px] items-start"></div>
              <div className="flex flex-col items-start w-[550px] ml-7">
                <p className="text-start text-slate-300 opacity-75">Quora</p>
              </div>
              <div className="flex flex-col w-[400px] items-center">
                <span
                  className="icon-[system-uicons--cross]"
                  style={{ width: "2rem", height: "2rem" }}
                ></span>
              </div>
              <div className="flex flex-col w-[400px] items-center">
                <span
                  className="icon-[system-uicons--cross]"
                  style={{ width: "2rem", height: "2rem" }}
                ></span>
              </div>
              <div className="flex flex-col w-[400px] items-center mr-5">
                <span
                  className="icon-[ic--sharp-check]"
                  style={{ width: "2rem", height: "2rem", color: "#7551CB" }}
                ></span>
              </div>
            </div>

            <div className="ml-3 h-[1px] w-[1200px] bg-slate-500 opacity-15"></div>

            <div className="flex flex-1">
              <div className="flex flex-col w-[50px] items-start"></div>
              <div className="flex flex-col items-start w-[550px] ml-7">
                <p className="text-start text-slate-300 opacity-75">Github</p>
              </div>
              <div className="flex flex-col w-[400px] items-center">
                <span
                  className="icon-[system-uicons--cross]"
                  style={{ width: "2rem", height: "2rem" }}
                ></span>
              </div>
              <div className="flex flex-col w-[400px] items-center">
                <span
                  className="icon-[system-uicons--cross]"
                  style={{ width: "2rem", height: "2rem" }}
                ></span>
              </div>
              <div className="flex flex-col w-[400px] items-center mr-5">
                <span
                  className="icon-[ic--sharp-check]"
                  style={{ width: "2rem", height: "2rem", color: "#7551CB" }}
                ></span>
              </div>
            </div>

            <div className="ml-3 h-[1px] w-[1200px] bg-slate-500 opacity-15"></div>

            <div className="flex flex-1">
              <div className="flex flex-col w-[50px] items-start"></div>
              <div className="flex flex-col items-start w-[550px] ml-7">
                <p className="text-start text-slate-300 opacity-75">Medium</p>
              </div>
              <div className="flex flex-col w-[400px] items-center">
                <span
                  className="icon-[system-uicons--cross]"
                  style={{ width: "2rem", height: "2rem" }}
                ></span>
              </div>
              <div className="flex flex-col w-[400px] items-center">
                <span
                  className="icon-[system-uicons--cross]"
                  style={{ width: "2rem", height: "2rem" }}
                ></span>
              </div>
              <div className="flex flex-col w-[400px] items-center mr-5">
                <span
                  className="icon-[ic--sharp-check]"
                  style={{ width: "2rem", height: "2rem", color: "#7551CB" }}
                ></span>
              </div>
            </div>

            <div className="ml-3 h-[1px] w-[1200px] bg-slate-500 opacity-15"></div>

            <div className="flex flex-1">
              <div className="flex flex-col w-[50px] items-start"></div>
              <div className="flex flex-col items-start w-[550px] ml-7">
                <p className="text-start text-slate-300 opacity-75">Flickr</p>
              </div>
              <div className="flex flex-col w-[400px] items-center">
                <span
                  className="icon-[system-uicons--cross]"
                  style={{ width: "2rem", height: "2rem" }}
                ></span>
              </div>
              <div className="flex flex-col w-[400px] items-center">
                <span
                  className="icon-[system-uicons--cross]"
                  style={{ width: "2rem", height: "2rem" }}
                ></span>
              </div>
              <div className="flex flex-col w-[400px] items-center mr-5">
                <span
                  className="icon-[ic--sharp-check]"
                  style={{ width: "2rem", height: "2rem", color: "#7551CB" }}
                ></span>
              </div>
            </div>

            <div className="ml-3 h-[1px] w-[1200px] bg-slate-500 opacity-15"></div>

            <div className="flex flex-1">
              <div className="flex flex-col w-[50px] items-start"></div>
              <div className="flex flex-col items-start w-[550px] ml-7">
                <p className="text-start text-slate-300 opacity-75">Yelp</p>
              </div>
              <div className="flex flex-col w-[400px] items-center">
                <span
                  className="icon-[system-uicons--cross]"
                  style={{ width: "2rem", height: "2rem" }}
                ></span>
              </div>
              <div className="flex flex-col w-[400px] items-center">
                <span
                  className="icon-[system-uicons--cross]"
                  style={{ width: "2rem", height: "2rem" }}
                ></span>
              </div>
              <div className="flex flex-col w-[400px] items-center mr-5">
                <span
                  className="icon-[ic--sharp-check]"
                  style={{ width: "2rem", height: "2rem", color: "#7551CB" }}
                ></span>
              </div>
            </div>
          </Accordion.Content>
        </Accordion.Item>
      </Accordion.Root>
    </div>
  );
};

export default AccordionComponent;
